import { render, staticRenderFns } from "./OwnerCreatePropertyView.vue?vue&type=template&id=6e37c533&scoped=true"
import script from "./OwnerCreatePropertyView.vue?vue&type=script&lang=js"
export * from "./OwnerCreatePropertyView.vue?vue&type=script&lang=js"
import style0 from "./OwnerCreatePropertyView.vue?vue&type=style&index=0&id=6e37c533&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e37c533",
  null
  
)

export default component.exports